import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { StyledComponentProps as _StyledComponentProps } from "styled-components";
var _excluded = ["name"];
import { iconNameAndRendererMap } from "@wantedly_private/ui-icons";
import React from "react";
import { DynamicIconButton } from ".";

/**
 * @deprecated In favor of `createIconButton` from "@wantedly_private/ui-react-2022"
 * Design: https://www.figma.com/file/oTPln5V0gbCuVLZ0EUG3pU/UIComponentsV2?node-id=2898%3A4346
 *
 * An Icon wrapped in a button component.
 */
export var IconButton = /*#__PURE__*/React.forwardRef(function IconButton(_ref, forwardedRef) {
  var name = _ref.name,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(DynamicIconButton, _extends({
    Icon: iconNameAndRendererMap[name],
    ref: forwardedRef
  }, restProps));
});
//# sourceMappingURL=IconButton.js.map